import React, { useEffect, useState } from "react";
import style from "./block.module.scss";
import apiFetch from '@wordpress/api-fetch';
import Tuile from "../shared/tuile";
import { useTranslation } from 'react-i18next';

function Block({actualId,type}){

    const {t} = useTranslation();
    const [events, setEvents] = useState();

    useEffect(() => {
        let path='/wp/v2/posts';
        if(type==="realisation"){
            path='/wp/v2/realisation'
        }
        apiFetch( { path: path+'?limit=3&exclude='+actualId + '&lang=' + window.localStorage.i18nextLng } ).then( value => {
                setEvents(value);
        });
    }, [actualId, setEvents, type]);

    return<div className={style.block}>
        <div className={style.content}>
            <h2 className={style.titre}>{t('À lire aussi')}</h2>
            <div className={style.events}>
                {events && events.map((value, index) => (
                    type ==="realisation"? <Tuile key={index} image={value.featured_img_url} category={value.acf['real-offre'].post_title} title={value.title.rendered} date={null} link={value.link} />
                    : <Tuile key={index} image={value.featured_img_url} category={value.category} title={value.title.rendered} date={value.date} link={value.link} />
                  )
                )}
            </div>
        </div>
    </div>
}

export default Block; 
